/* eslint-disable @typescript-eslint/no-explicit-any */

import { Amplify } from 'aws-amplify';
import * as auth from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import awsExports from 'aws-exports';
import { BehaviorSubject } from 'rxjs';



Amplify.configure(awsExports);



export function evaluateInitialIsLoggedIn() {
  // Type casting for Amplify because the types don't seem to match what amplify has
  const exports = awsExports as any;
  const lastAuthUser = localStorage.getItem(`CognitoIdentityServiceProvider.${exports.aws_user_pools_web_client_id ?? ''}.LastAuthUser`);
  return lastAuthUser !== null;
}

export const subjChangeAuthStatus = new BehaviorSubject<boolean>(evaluateInitialIsLoggedIn());



let __holdEventsFlag = false;

const heldEventsQueue: string[] = [];


export function releaseEvents() {
  while (heldEventsQueue.length > 0) {
    handleHubEvent(heldEventsQueue.shift() ?? '');
  }
  __holdEventsFlag = false;
}

export function holdEvents() {
  __holdEventsFlag = true;
}


function handleHubEvent(event: string) {
  if (event === 'signedIn') {
    subjChangeAuthStatus.next(true);
  } else if (event === 'signedOut') {
    // Sign out
    subjChangeAuthStatus.next(false);

  }
}


Hub.listen('auth', async ({ payload }) => {
  if (!__holdEventsFlag) {
    handleHubEvent(payload.event);
  } else {
    heldEventsQueue.push(payload.event);
  }
});


// function that takes arg (val: 'signedIn' | 'signedOut' | null)
// add mechanism via flag that iwll call function directly other will act with hub
// if flag is up
// stick event value into list while flag is up - events will accumulate(should realistically be single but could more)
// process the flag then put the flag down
// rip through the list starting at first and call into logic function and once empty put flag down
// function that will put flag down

export async function signIn(email: string, password: string) {
  return auth.signIn({
    username: email.trim(),
    password: password.trim()
  });
}



export async function signUp(email: string, password: string) {
  const { nextStep } = await auth.signUp({
    username: email.trim(),
    password: password.trim()
  });

  return nextStep.signUpStep;
}



export async function confirmSignUp({
  email, confirmationCode
}: {
  email: string;
  password: string;
  confirmationCode: string;
}) {
  const resp = await auth.confirmSignUp({
    username: email.trim(),
    confirmationCode: confirmationCode.trim()
  });
  return resp;
}



export async function signOut() {
  await auth.signOut({
    global: true
  });
}



export async function setUpTOTP() {
  return auth.setUpTOTP();
}



export async function resetPassword(email: string) {
  await auth.resetPassword({
    username: email
  });
}



export async function confirmResetPassword({
  email, password, confirmationCode
}: {
  email: string;
  password: string;
  confirmationCode: string;
}) {
  await auth.confirmResetPassword({
    username: email,
    newPassword: password,
    confirmationCode
  });
}



export const getAccessToken = async () => {
  try {
    const session = await auth.fetchAuthSession();
    if (session.tokens) {
      // write to the cache the values
      return session.tokens.accessToken.toString();
    }

    return null;

  } catch (err) {
    return null;
  }
};



export async function verify(code: string) {
  return auth.verifyTOTPSetup({
    code
  });
}



export async function confirmSignIn(code: string) {
  return auth.confirmSignIn({
    challengeResponse: code
  });
}
